import React from 'react';
import { Link } from 'react-router-dom';
import { usePremium } from '@/context/PremiumContext';

export default function FantasyAvailabilityGate({ children }) {
  const { catalog, loading, error, refresh } = usePremium();
  if (loading) return <div role="status" className="p-8 text-center text-slate-400">Vérification de la disponibilité…</div>;
  if (error) return <div role="alert" className="p-8 text-center text-slate-300">Impossible de vérifier la disponibilité. <button onClick={refresh} className="font-bold underline">Réessayer</button></div>;
  if (catalog?.availability?.fantasy === true) return children;
  return <section className="mx-auto max-w-xl px-6 py-20 text-center" data-testid="fantasy-paused">
    <p className="text-xs font-bold uppercase tracking-widest text-emerald-400">DayOne FC</p>
    <h1 className="mt-4 font-head text-3xl font-bold">Fantasy est en pause</h1>
    <p className="mt-4 leading-relaxed text-slate-300">Les collections et l’historique sont conservés. Retrouve les autres rubriques de ta carrière depuis l’accueil.</p>
    <Link to="/" className="mt-7 inline-flex rounded-xl bg-emerald-400 px-5 py-3 font-semibold text-slate-950">Retour à l’accueil</Link>
  </section>;
}
